import {
    PROCESS_RATES_TEMPLATE_FAILURE,
    PROCESS_RATES_TEMPLATE_REQUEST,
    PROCESS_RATES_TEMPLATE_SUCCESS,
    VerifiedSummary,
    VERIFY_PROCESS_RATES_FAILURE,
    VERIFY_PROCESS_RATES_REQUEST,
    VERIFY_PROCESS_RATES_SUCCESS,
    SUBMIT_PROCESS_RATES_REQUEST,
    SUBMIT_PROCESS_RATES_SUCCESS,
    SUBMIT_PROCESS_RATES_FAILURE,
    SET_ACTIVE_STEP,
    FileStatus,
    PROCESS_RATES_HISTORY_REQUEST,
    PROCESS_RATES_HISTORY_SUCCESS,
    PROCESS_RATES_HISTORY_FAILURE,
    PROCESSED_RATES_REQUEST,
    PROCESSED_RATES_FAILURE,
    PROCESSED_RATES_SUCCESS,
    FileHistory,
    PROCESS_RATES_IS_PENDING
} from '../../actions/truckLoadRate/processRatesActions';

export interface ProcessRates {
    isDownloadingProcessRatesTemplate: boolean;
    isProcessing: boolean;
    verifiedSummary: VerifiedSummary | {};
    fileStatus: FileStatus | {};
    activeStep: number;
    isFetchingHistory: boolean;
    fileHistory: FileHistory | { content: FileStatus[] };
    isDownloadingProcessedRates: boolean;
    isPending: boolean;
}

const fetchProcessRatesReducers = (processRates: ProcessRates = {
    isDownloadingProcessRatesTemplate: false,
    isProcessing: false,
    verifiedSummary: {},
    fileStatus: {},
    activeStep: 0,
    isFetchingHistory: false,
    fileHistory: { content: [] },
    isDownloadingProcessedRates: false,
    isPending: false
}, action: any): ProcessRates => {
    switch (action.type) {
        case PROCESS_RATES_TEMPLATE_REQUEST: {
            return {
                ...processRates,
                isDownloadingProcessRatesTemplate: true
            };
        }
        case PROCESS_RATES_TEMPLATE_SUCCESS: {
            return {
                ...processRates,
                isDownloadingProcessRatesTemplate: false
            };
        }
        case PROCESS_RATES_TEMPLATE_FAILURE: {
            return {
                ...processRates,
                isDownloadingProcessRatesTemplate: false
            };
        }
        case VERIFY_PROCESS_RATES_REQUEST: {
            return {
                ...processRates,
                isProcessing: true
            };
        }
        case VERIFY_PROCESS_RATES_SUCCESS: {
            return {
                ...processRates,
                isProcessing: false,
                verifiedSummary: action.payload
            };
        }
        case VERIFY_PROCESS_RATES_FAILURE: {
            return {
                ...processRates,
                isProcessing: false
            };
        }
        case SET_ACTIVE_STEP: {
            return {
                ...processRates,
                activeStep: action.payload
            };
        }
        case SUBMIT_PROCESS_RATES_REQUEST: {
            return {
                ...processRates,
                isProcessing: true
            };
        }
        case SUBMIT_PROCESS_RATES_SUCCESS: {
            return {
                ...processRates,
                isProcessing: false,
                fileStatus: action.payload
            };
        }
        case SUBMIT_PROCESS_RATES_FAILURE: {
            return {
                ...processRates,
                isProcessing: false
            };
        }
        case PROCESS_RATES_HISTORY_REQUEST: {
            return {
                ...processRates,
                isFetchingHistory: true
            };
        }
        case PROCESS_RATES_HISTORY_SUCCESS: {
            return {
                ...processRates,
                isFetchingHistory: false,
                fileHistory: action.payload
            };
        }
        case PROCESS_RATES_HISTORY_FAILURE: {
            return {
                ...processRates,
                isFetchingHistory: false,
                fileHistory: { content: [] }
            };
        }
        case PROCESSED_RATES_REQUEST: {
            return {
                ...processRates,
                isDownloadingProcessedRates: true
            };
        }
        case PROCESSED_RATES_SUCCESS: {
            return {
                ...processRates,
                isDownloadingProcessedRates: false
            };
        }
        case PROCESSED_RATES_FAILURE: {
            return {
                ...processRates,
                isDownloadingProcessedRates: false
            };
        }
        case PROCESS_RATES_IS_PENDING: {
            return {
                ...processRates,
                isPending: action.payload
            };
        }
        default:
            return processRates;
    }
};

export default fetchProcessRatesReducers;
